import React from 'react'
import { STEP_TYPE_ENUM, TASK_TYPE_ENUM } from 'services/api/constants'
import { Section, Title } from '../../../Shared'
import { BaseEditorContainer, EditorContentCardContainer } from '../../styles'
import Field from 'components/Shared/Fields'
import BaseDivider from '../../BaseDivider'
import ExtraTextEditor from '../../ExtraTextEditor'
import CampaignEditorInputFieldContainer from 'components/Shared/Permission/CampaignEditorInputFieldContainer'
import { useNewTranslation } from 'hooks'
import Header from '../../Header'
import { fieldIdentifiers } from 'components/Shared/Comment'
import { FormikTextListGroup } from 'particles/TextInputs/TextList/Group'

interface AttendEventProps {
    taskType: TASK_TYPE_ENUM
    stepType: STEP_TYPE_ENUM
    stepNumber: number
    requiredFieldNames: string[]
    uuid?: string
}

const AttendEvent: React.FC<AttendEventProps> = ({ taskType, stepType, stepNumber, requiredFieldNames, uuid }) => {
    const [t] = useNewTranslation()
    return (
        <BaseEditorContainer id={uuid && uuid}>
            <EditorContentCardContainer>
                <Header taskType={taskType} />
                <Title taskType={taskType} stepType={stepType} stepNumber={stepNumber} />
                <CampaignEditorInputFieldContainer>
                    <Field.TextInputField
                        className={'input-area'}
                        label={t('campaignEditor.createTask.enterStepTitleHeader')}
                        placeholder={t('taskType.attendEvent')}
                        name={`stepData.${stepType}.data.title`}
                        isRequired={requiredFieldNames.includes('title')}
                        width={'100%'}
                        identifier={`${uuid}_${fieldIdentifiers.stepTitle}`}
                    />
                </CampaignEditorInputFieldContainer>
                <BaseDivider />
                <Section
                    title={t('campaignEditor.createTask.describeEventHeader')}
                    subtitle={t('campaignEditor.createTask.describeEventSubtext')}
                >
                    <CampaignEditorInputFieldContainer>
                        <Field.TextInputField
                            className={'input-area'}
                            label={t('campaignEditor.createTask.enterEventNameHeader')}
                            name={`stepData.${stepType}.data.event_name`}
                            isRequired={requiredFieldNames.includes('event_name')}
                            width={'100%'}
                            identifier={`${uuid}_${fieldIdentifiers.eventName}`}
                        />
                        <Field.TextAreaField
                            label={t('campaignEditor.createTask.enterEventDescriptionHeader')}
                            name={`stepData.${stepType}.data.description`}
                            isRequired={requiredFieldNames.includes('description')}
                            width={'100%'}
                            minTextAreaHeight={76}
                            showInputLength
                            maxInputLength={200}
                            identifier={`${uuid}_${fieldIdentifiers.eventDescription}`}
                        />
                        <FormikTextListGroup
                            title={t('campaignEditor.createTask.enterEventInformationHeader')}
                            subtitle={t('campaignEditor.createTask.enterEventInformationSubtext')}
                            placeholder={t('placeholderText.enterEventDetailsBulletPoint')}
                            buttonText={t('button.addBulletPoint')}
                            name={`stepData.${stepType}.data.event_information`}
                            dataTestId="test-event-information"
                            isRequired={requiredFieldNames.includes('event_information')}
                            isDefault
                            width={'100%'}
                            identifier={`${uuid}_${fieldIdentifiers.eventInformation}`}
                        />
                    </CampaignEditorInputFieldContainer>
                </Section>
                <CampaignEditorInputFieldContainer>
                    <ExtraTextEditor name={`stepData.${stepType}.data.extra_data`} isRequired />
                </CampaignEditorInputFieldContainer>
            </EditorContentCardContainer>
        </BaseEditorContainer>
    )
}

export default AttendEvent
